import client from '../../../api/client';

/**
 * Retrieves the list of workspaces for the current authenticated user.
 * @returns {Promise<Array>} The list of workspace objects.
 */
export const getWorkspaces = async () => {
  const response = await client.get('/api/workspace');
  return response.data;
};

/**
 * Retrieves the full manifest details of a specific workspace context.
 * @param {string} id - The unique identifier of the workspace.
 * @returns {Promise<Object>} The workspace manifest details.
 */
export const getWorkspace = async (id) => {
  const response = await client.get(`/api/workspace/${id}`);
  return response.data;
};

/**
 * Creates a new workspace context with the provided profile parameters.
 * @param {Object} data - Payload containing workspace settings (e.g. name, target_role, target_jd).
 * @returns {Promise<Object>} The created workspace object metadata.
 */
export const createWorkspace = async (data) => {
  const response = await client.post('/api/workspace', data);
  return response.data;
};

/**
 * Updates an existing workspace context properties.
 * @param {string} id - The unique identifier of the workspace to update.
 * @param {Object} data - Payload containing fields to update.
 * @returns {Promise<Object>} The updated workspace object.
 */
export const updateWorkspace = async (id, data) => {
  const response = await client.put(`/api/workspace/${id}`, data);
  return response.data;
};

/**
 * Deletes the specified workspace context and cascades removal to child documents.
 * @param {string} id - The unique identifier of the workspace to delete.
 * @returns {Promise<Object>} Response confirmation object.
 */
export const deleteWorkspace = async (id) => {
  const response = await client.delete(`/api/workspace/${id}`);
  return response.data;
};
